export default __webpack_public_path__ + "static/media/PLP-β.5d4a3e01.svg";